import { createProviderToken } from '@core/common-legacy';

// availability is whether action is available for that component
// then user either can or cannot perform that action, depending on canEdit value
export type VisualizationActionsAvailability = {
  canEdit: boolean;
  duplicateAvailable: boolean;
  moveAvailable: boolean;
  exportAvailable: boolean;
  deleteAvailable: boolean;
};

// Options passed as tokens to visualizations, that define functionality
export interface ReportVisualizationOptions {
  tableSortingAvailable?: boolean;
}

export const {
  provide: provideReportVisualizationOptions,
  inject: injectReportVisualizationOptions,
} = createProviderToken<ReportVisualizationOptions>('ReportVisualizationOptions')();
